export var SET_PROJECT = 'SET_PROJECT';
export var LOAD_PROJECT = 'LOAD_PROJECT';
export var LOAD_PROJECT_PREVIEW = 'LOAD_PROJECT_PREVIEW';
export var LOAD_PROJECT_PREVIEW_STARTING = 'LOAD_PROJECT_PREVIEW_STARTING';
export var LOAD_PROJECT_PREVIEW_DONE = 'LOAD_PROJECT_PREVIEW_DONE';
export var LOAD_PROJECT_PREVIEW_FAILED = 'LOAD_PROJECT_PREVIEW_FAILED';
export var LOAD_FULL_PROJECT = 'LOAD_FULL_PROJECT';
export var LOAD_FULL_PROJECT_STARTING = 'LOAD_FULL_PROJECT_STARTING';
export var LOAD_FULL_PROJECT_DONE = 'LOAD_FULL_PROJECT_DONE';
export var LOAD_FULL_PROJECT_FAILED = 'LOAD_FULL_PROJECT_FAILED';
export var NOT_FOUND = 'NOT_FOUND';
export var SET_IS_DOWNLOADED = 'SET_IS_DOWNLOADED';
export var SET_PROJECT_PLAN = 'SET_PROJECT_PLAN';
export var SET_SHOW_TOUCH_INDICATORS = 'SET_SHOW_TOUCH_INDICATORS';
export var SET_FRAMELESS = 'SET_FRAMELESS';
export var SET_BASIC = 'SET_BASIC';
